import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MzModalComponent, MzModalService } from 'ngx-materialize';
import { ToastrService } from 'ngx-toastr';
import { ROUTE_ANIMATION, ROUTE_ANIMATION_HOST } from 'src/app/app.routing.animation';
import { DatatableComponent } from 'src/app/semantic/datatable/datatable.component';
import { DeletemodalConfigEsqComponent } from 'src/app/semantic/deletemodal-config-esq/deletemodal-config-esq.component';
import { ModaleditConfigEsquComponent } from 'src/app/semantic/modaledit-config-esqu/modaledit-config-esqu.component';
import { CatalogoModel } from 'src/app/_models/bin-catalogos.model';
import { configuracionEsquema } from 'src/app/_models/formularios/configuracionEsquemas.model';
import { REST_SERVICES } from 'src/app/_services/settings';
import { ZeroService } from 'src/app/_services/zero/zero.service';

@Component({
  selector: 'app-configuracion',
  templateUrl: './configuracion.component.html',
  host: ROUTE_ANIMATION_HOST,
  animations: [ROUTE_ANIMATION],
  encapsulation: ViewEncapsulation.None
})
export class ConfiguracionComponent implements OnInit {
  public config: configuracionEsquema;
  public configAlta: configuracionEsquema;
  // Datatable componentes
  public rowsDataTableConfigEsquema: Array<configuracionEsquema> = [];
  public catalogoPlantillas: Array<CatalogoModel>;
  public catalogoInstituciones: Array<CatalogoModel>;
  public catalogoTipoBin: Array<CatalogoModel>;
  public catalogoEsquemas: Array<CatalogoModel>;
  public columnsDataTableConfigEsq: Array<any> = [];
  public idEsquema: number
  @ViewChild('altaConfigEsq') altaConfigEsq: MzModalComponent;
  @ViewChild('ErrorAltaConfig') ErrorAltaConfig: MzModalComponent;
  //

  // Templates datatable columns
  @ViewChild(DatatableComponent) dataTableComp: DatatableComponent;

  constructor(private zeroService: ZeroService,
    private toast: ToastrService, public router: Router,
    private modalServiceConfigEsqDelete: MzModalService,
    private modalServiceConfigEsquEdit: MzModalService,) {
    this.config = new configuracionEsquema();
    this.configAlta = new configuracionEsquema();
    this.catalogoPlantillas = new Array<CatalogoModel>();
    this.catalogoInstituciones = new Array<CatalogoModel>();
    this.catalogoTipoBin = new Array<CatalogoModel>();
    this.catalogoEsquemas = new Array<CatalogoModel>();
  }

  ngOnInit() {
    this.buscarCatalogosEsquema();
    this.buscarCatalogosInstitucion();
    this.buscarCatalogosPlantilla();
    this.buscarCatalogosTipoBin();
    this.buscarConfigs();
    this.validaConfig();
  }
  buscarConfigs() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.BUSQUEDA_CONFIGURACIONES_ESQUEMA,
      method: "POST",
      swhowInfo: true,
      params: scope.config,
      ok: (response) => {
        scope.rowsDataTableConfigEsquema = new Array<configuracionEsquema>();
        if (response.responsecode == "0") {
          scope.rowsDataTableConfigEsquema = response.response;
        }
      }
    });
  }

  validaConfig() {
    this.dataTableComp.onEventTemplate.subscribe(selected => {
      this.validaAccionConfigEsq(selected.rowSelect, selected.accion);
    });

    this.columnsDataTableConfigEsq = [
      { name: "ESQUEMA", prop: "esquema", width: 60 },
      { name: "INSTITUCIÓN", prop: "institucion", width: 250 },
      { name: "PLANTILLA", prop: "plantilla", width: 110 },
      { name: "TIPO BIN", prop: "tipoBin", width: 150 },
      { name: "OPCIONES DE CONFIGURACIÓN", cellTemplate: this.dataTableComp.columConfig, width: 150 },
    ];
  }

  buscarCatalogosTipoBin() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_TIPO_BIN,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoTipoBin = response.response;
      }
    });
  }
  buscarCatalogosPlantilla() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_PLANTILLAS,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoPlantillas = response.response;
      }
    });
  }
  buscarCatalogosEsquema() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_ESQUEMAS,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoEsquemas = response.response;
      }
    });
  }
  buscarCatalogosInstitucion() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_INSTITUCIONES.replace("%id", "5"),
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoInstituciones = response.response;
      }
    });
  }

  setEsquema(idEsquema: number) {
    this.config.idEsquema = idEsquema;

  }
  setPlantilla(idPlantilla: number) {
    this.config.idPlantilla = idPlantilla;
  }
  setInstitucion(idInstitucion: number) {
    this.config.idInstitucion = idInstitucion;
  }
  setTipoBin(idtipoBin: number) {
    this.config.idTipoBin = idtipoBin;
  }
  guardarConfig() {
    let scope = this;
    if (scope.configAlta.idEsquema == null || scope.configAlta.idEsquema == undefined ||
      scope.configAlta.idTipoBin == null || scope.configAlta.idTipoBin == undefined ||
      scope.configAlta.idInstitucion == null || scope.configAlta.idInstitucion == undefined ||
      scope.configAlta.idPlantilla == null || scope.configAlta.idPlantilla == undefined) {
      this.ErrorAltaConfig.openModal();
    } else {
      this.altaConfigEsq.closeModal();
      this.zeroService.request({
        uri: REST_SERVICES.NUEVA_CONFIGURACION_ESQUEMA,
        method: "POST",
        showInfo: true,
        isSingleResponse: false,
        params: scope.configAlta,
        ok: function (response) {
          if (response.responsecode == "0") {
            scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
              { closeButton: false, enableHtml: true, disableTimeOut: false });
            scope.router.navigate(['/Configuracion'], {
              queryParams: { refresh: new Date().getTime() }
            });
            scope.limpiarConfig();
            scope.buscarConfigs();
          }
        }
      });
    }
  }
  cancelarAltaConfig() {
    this.altaConfigEsq.closeModal();
    this.limpiarConfig();
    this.router.navigate(['/Configuracion'], {
      queryParams: { refresh: new Date().getTime() }
    });
  }
  limpiarConfig() { 
    this.config = new configuracionEsquema();
    this.idEsquema = 0;
    this.config.idEsquema = null;
    this.configAlta = new configuracionEsquema();
    this.configAlta.idEsquema = null;
    this.buscarConfigs();
  }

  validaAccionConfigEsq(rowSelect: any, accion: any) {
    if (accion == "deleteConfig") {
      this.validaEliminarConfigEsq(rowSelect);
    }

    if (accion == "editConfig") {
      this.validaEdicionConfigEsq(rowSelect);
    }
  }
  validaEdicionConfigEsq(rowSelect: any) {
    this.modalEditConfigEsqu(rowSelect);
  }
  modalEditConfigEsqu(rowSelect: any) {
    let configInput = this.validaConfigInput(rowSelect);
    let modaleditcamp: any = this.modalServiceConfigEsquEdit.open(ModaleditConfigEsquComponent, {
      configEditIn: configInput

    });
    modaleditcamp.instance.updateConfig.subscribe(configEsqu => {
      this.updateConfigEdit(configEsqu);

    });
  }
  updateConfigEdit(configEsqu: any) {
    let scope = this;
    this.zeroService.request({
      uri: REST_SERVICES.ACTUALIZAR_CONFIGURACION_ESQUEMA,
      method: "PUT",
      showInfo: true,
      isSingleResponse: false,
      params: configEsqu,
      ok: function (response) {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Configuracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.limpiarConfig();
          scope.buscarConfigs();

        }
      }
    })
  }
  validaEliminarConfigEsq(rowSelect: any) {
    this.modalEliminarConfigEsq(rowSelect)
  }
  modalEliminarConfigEsq(rowSelect: any) {
    let modaldrop: any = this.modalServiceConfigEsqDelete.open(DeletemodalConfigEsqComponent, {});
    modaldrop.instance.onOkModalComment.subscribe(comentario => {
      if (comentario) {
        this.eliminarConfigEsqu(rowSelect);
      }
    });
  }
  eliminarConfigEsqu(rowSelect: any) {
    let scope = this;
    let configDelete = this.validaConfigInput(rowSelect);
    this.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.ELIMINAR_CONFIGURACION_ESQUEMA,
      method: "PUT",
      showInfo: true,
      params: configDelete,
      ok: (response) => {
        if (response.responsecode == "0") {
          scope.toast.success('<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
          scope.router.navigate(['/Configuracion'], {
            queryParams: { refresh: new Date().getTime() }
          });
          scope.limpiarConfig();
          scope.buscarConfigs();
        }
      }
    });
  }
  validaConfigInput(rowSelect) {
    let configEs: configuracionEsquema;
    configEs = new configuracionEsquema();
    configEs.idEsquema = rowSelect.idEsquemaFk;
    configEs.idInstitucion = rowSelect.idInstitucionFk;
    configEs.idPlantilla = rowSelect.idPlantillaFk;
    configEs.idTipoBin = rowSelect.idTipoBinFk;
    return configEs;
  }

}
